import { render } from "./PictureCollection.vue?vue&type=template&id=d35f6df6&scoped=true"
import script from "./PictureCollection.vue?vue&type=script&lang=js"
export * from "./PictureCollection.vue?vue&type=script&lang=js"

import "./PictureCollection.vue?vue&type=style&index=0&id=d35f6df6&scoped=true&lang=css"

import exportComponent from "H:\\Takahammas\\website\\takahammas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35f6df6"]])

export default __exports__